import * as React from "react";
import Component from "../../AbstractComponent";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Constants from "../../../Action/Constants";
import ContactsUpdateWillMount from "../../../Middleware/Middlewares/ContactsUpdateWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";

export class TabsComponent extends Component {
  protected middlewares: MiddlewareInterface[] = [
    ContactsUpdateWillMount
  ];

  public state = {
    value: this.props.activeTab
  };

  constructor(public props) {
    super(props);
  }

  public switchTab = (event, tabValue) => {
    event

    this.setState({
      value: tabValue
    });

    this.props.dispatch({
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: tabValue
      }
    });

    const redirect: string = tabValue === 0 ? "persons" : "companies";

    this.redirect(`/app/contacts/${redirect}`)
  }

  public render() {
    return (
      <Tabs className={`tab tab-simple tab-contains-2 half-size light-tabs`}
        onChange={this.switchTab}
        value={this.state.value}
      >
        <Tab
          value={0}
          label={this.trans("title-persons")}
        />

        <Tab
          value={1}
          label={this.trans("title-companies")}
        />
      </Tabs>
    );
  }
}